import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer, PageHeader } from "@fleet/ui";
import { StaffManager } from "@/features/staff/components/staff-manager";
import { RestaurantGate } from "@/features/pos/components/restaurant-gate";
import { useActiveContext } from "@/features/pos/hooks/use-active-context";
import { useI18n } from "@/providers/i18n-provider";

function StaffPage() {
  const { t } = useI18n();
  const ctx = useActiveContext();
  return (
    <PageContainer maxWidth="5xl">
      <PageHeader title={t(msg`Staff`)} />
      <RestaurantGate ctx={ctx}>
        {(c) => <StaffManager org={c.org} branch={c.branch} />}
      </RestaurantGate>
    </PageContainer>
  );
}

export const staffRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/staff",
  component: StaffPage,
});
